/**
 * @file コンポーネント：利用規約 DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Tab } from "~/src/components/projects/Tab";
import { TermsEnglish } from "~/src/components/projects/TermsEnglish";
import { TermsJapanese } from "~/src/components/projects/TermsJapanese";

// 関数読み込み
import { fnReplaceLocalizedText } from "~/src/functions/common";

// スタイル読み込み
import {
    StyledTerms,
    StyledTermsContainer,
    StyledTermsFrame,
    StyledTermsLabel,
    StyledTermsLabelCheckbox,
    StyledTermsLabelText,
    StyledTermsParagraph,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledTerms>
            {/* 見出し */}
            {props.hasAgreeCheck === true && (
                <StyledTermsParagraph data-on-color={props.onColor}>
                    {localized["Label.CheckTerms"]}
                </StyledTermsParagraph>
            )}
            {/* 利用規約タブ */}
            <Tab
                list={[
                    {
                        content: [
                            <StyledTermsFrame
                                data-frame-scroll={props.frameScroll}
                                key="en"
                                ref={props.refFrameEn}
                            >
                                <StyledTermsContainer
                                    ref={props.refContainerEn}
                                >
                                    <TermsEnglish onColor={props.onColor} />
                                </StyledTermsContainer>
                            </StyledTermsFrame>,
                        ],
                        name: "en",
                        triggerText: "English",
                    },
                    {
                        content: [
                            <StyledTermsFrame
                                data-frame-scroll={props.frameScroll}
                                key="ja"
                                ref={props.refFrameJa}
                            >
                                <StyledTermsContainer
                                    ref={props.refContainerJa}
                                >
                                    <TermsJapanese onColor={props.onColor} />
                                </StyledTermsContainer>
                            </StyledTermsFrame>,
                        ],
                        hasContent: props.languageCode === "ja", // 日本語がUI表示言語の場合のみ表示
                        name: "ja",
                        triggerText: "日本語",
                    },
                ]}
                onColor={props.onColor}
                selectedTab={props.languageCode}
                triggerSize="full"
            />
            {/* 同意するチェックボックス */}
            {props.hasAgreeCheck === true && (
                <StyledTermsLabel className={props.isReaded ? "isReaded" : ""}>
                    <StyledTermsLabelCheckbox
                        data-val="true"
                        data-val-range={localized["ErrorMessage.AgreeTerms"]}
                        data-val-range-max="True"
                        data-val-range-min="True"
                        data-val-required={fnReplaceLocalizedText(
                            localized["ErrorMessage.Required"],
                            [localized["Label.IAgree"]]
                        )}
                        defaultChecked={props.isAgreed}
                        disabled={!props.isReaded}
                        name="Agree"
                        onChange={() => props.setIsAgreed(!props.isAgreed)}
                        type="checkbox"
                        value="true"
                    />
                    <StyledTermsLabelText data-on-color={props.onColor}>
                        {localized["Label.IAgree"]}
                    </StyledTermsLabelText>
                </StyledTermsLabel>
            )}
        </StyledTerms>
    );
};
